import { Link } from "wouter";
import img from "../../public/lovable-uploads/794bcc8e-4338-4129-9bd7-38e76b939a38.png";
import { useEffect, useState } from "react";
import { fetchPageContent } from "@/api/apis";
export default function Footer() {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchPageContent("footer").then((res) => {
      const sections = ["info"];
      const sectionsData: any = {};

      Object.keys(res.data.content).map((fieldKey) => {
        const fieldSection = sections.find((sec) => fieldKey.includes(sec));

        if (fieldSection) {
          sectionsData[fieldSection] = {
            ...(sectionsData[fieldSection] || {}),
            [fieldKey.replace(fieldSection + "_", "")]:
              res.data.content[fieldKey],
          };
        }
      });

      setContent(sectionsData);
    });
  }, []);
  return (
    <footer className="section-dark border-t border-musicGrey/20 pt-16 pb-8 section-transition">
      <div className="editorial-container">
        {/* ── MAIN CONTENT ───────────────────────────────── */}
        <div className="flex flex-col md:flex-row justify-between gap-12">
          {/* LEFT  ─ logo + tagline */}
          <div className="max-w-sm">
            <Link to="/" className="inline-block mb-6">
              <img src={img} alt="Music Nation Logo" className="h-16 w-auto" />
            </Link>
            {content?.info && (
              <p className="text-musicGrey font-sans">{content.info.text}</p>
            )}
          </div>
        </div>

        {/* ── BOTTOM BAR ─────────────────────────────────────── */}
        <div className="mt-16 pt-8 border-t border-musicGrey/20 text-center">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <span className="text-musicGrey text-sm font-sans mb-4 md:mb-0">
              © 2025 Music Nation. All rights reserved.
            </span>
            <div className="flex space-x-6">
              <Link
                to="/privacy-policy"
                className="text-musicGrey hover:text-musicRed transition-colors text-sm font-sans"
              >
                Privacy Policy
              </Link>
              <span className="text-musicGrey">·</span>
              <Link
                to="/term-of-use"
                className="text-musicGrey hover:text-musicRed transition-colors text-sm font-sans"
              >
                Terms of Service
              </Link>
              <span className="text-musicGrey">·</span>
              <Link
                to="/contact"
                className="text-musicGrey hover:text-musicRed transition-colors text-sm font-sans"
              >
                Contact
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
